export function latexToPlainText(latex) {
  return latex
    .replace(/\b(begin|end)\{\w+\}/g, '')
    .replace(/\\.?frac\{(([^{}]|\{[^{}]*\})*)\}\{(([^{}]|\{[^{}]*\})*)\}/g, (_, p1, p2, p3) =>
      [p1, p3].map(p => (/^[A-Za-z0-9]+$/.test(p) ? p : `(${p})`)).join('/'),
    )
    .replace(/\\[A-Za-z]+/g, m => LATEX_FUNCTION_MAP[m.substring(1)] || '')
    .replaceAll('\\{', '\ue000')
    .replaceAll('\\}', '\ue001')
    .replace(/[{}]/g, '')
    .replaceAll('\ue000', '{')
    .replaceAll('\ue001', '}')
    .replaceAll('\\', '')
    .replaceAll('&', '');
  // .replace(/(?<!\\)[{}]/g, '') // invalid regex bugs out Safari
}

const LATEX_FUNCTION_MAP = {
  rightarrow: '⭢',
  leftarrow: '⭠',
  to: '→',
  lim: 'lim',
  sqrt: '√',
  infty: '∞',
  delta: 'δ',
  mu: 'μ',
  pi: 'π',
  alpha: 'α',
  beta: 'β',
  epsilon: 'ϵ',
  lambda: 'λ',
  phi: 'ϕ',
  psi: 'ψ',
  omega: 'ω',
  sigma: 'σ',
  int: '∫',
  in: '∈',
  notin: '∉',
  geq: '≥',
  ge: '≥',
  leq: '≤',
  le: '≤',
  pm: '±',
  cdot: '⋅',
  sum: '∑',
  sin: 'sin',
  tan: 'tan',
  cos: 'cos',
  arctan: 'arctan',
  ln: 'ln',
};
